import { AiChatWebComponent } from './component/AiChatWebComponent';
import { WEB_COMPONENT_AI_CHAT } from '../../webcomponents.constants';

export { AiChatWebComponent };

window.customElements.define(WEB_COMPONENT_AI_CHAT, AiChatWebComponent);
